import { makeStyles, Tab, TabList } from "@fluentui/react-components";

interface IPaginationProps {
    pages: number;
    selectedPage: number;
    setSelectedPage: (page: number) => void;
}

const useStyles = makeStyles({
    root: {
        display: "block",
        width: "100%",
    },
    container: {
        display: "flex",
        flexWrap: "wrap",
        maxWidth: "1200px",
        justifyContent: "center",
        margin: "0 auto",
        paddingTop: "32px",
        paddingBottom: "calc(32px - 1rem)",

        "@media screen and (max-width: 768px)": {
            flexWrap: "nowrap",
            overflowX: "auto",
            justifyContent: "flex-start",
            paddingLeft: "1rem",
            paddingRight: "1rem",
        }
    }
});

export default function Pagination(props: IPaginationProps) {
    const styles = useStyles();

    return (
        <div className={styles.root}>
            <div className={styles.container}>
                <TabList selectedValue={props.selectedPage} defaultSelectedValue={props.selectedPage} appearance="filled-circular">
                    {
                        Array.from({ length: props.pages }, (_, index) => (
                            <Tab
                                key={index + 1}
                                value={index + 1}
                                onClick={() => props.setSelectedPage(index + 1)}
                            >
                                {index + 1}
                            </Tab>
                        ))
                    }
                </TabList>
            </div>
        </div>
    );
}